import { render } from "./PeopleMediumDevice.vue?vue&type=template&id=7503b20d&scoped=true"
import script from "./PeopleMediumDevice.vue?vue&type=script&lang=js"
export * from "./PeopleMediumDevice.vue?vue&type=script&lang=js"

import "./PeopleMediumDevice.vue?vue&type=style&index=0&id=7503b20d&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7503b20d"]])

export default __exports__